import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useState, useCallback, useMemo } from 'react';
import Transition from 'react-transition-group/Transition';
import { reDraw } from '../../../../../helpers/common';
import { propArrayShape, propFunc, propNumber, } from '../../../../../helpers/custom-prop-types';
import Image from '../../../Common/Image';
const FullScreenModalLeft = (props) => {
    const { changeActiveColumn, imageIndex, images, onClickImage: rawOnClickImage, } = props;
    const [isOpen, changeIsOpen] = useState(false);
    const hideIsOpen = useCallback(() => {
        changeIsOpen(false);
        changeActiveColumn('');
    }, [changeIsOpen, changeActiveColumn]);
    const toggleIsOpen = useCallback(() => {
        changeIsOpen((prev) => !prev);
        changeActiveColumn('left');
    }, [changeIsOpen, changeActiveColumn]);
    const onClickImage = useCallback((e) => {
        const value = e.currentTarget.getAttribute('data-value');
        rawOnClickImage(parseInt(value, 10));
    }, [rawOnClickImage]);
    const elementProps = useMemo(() => ({
        'data-body-scroll-lock-ignore': '1',
    }), []);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'full_screen_modal_left' }, { children: [_jsx(Transition, Object.assign({ in: isOpen, onEnter: reDraw, timeout: 500 }, { children: (state) => (_jsx("div", Object.assign({ className: `full_screen_modal_left_images ${state}` }, elementProps, { children: images.map(({ id, value }) => (_jsx("div", Object.assign({ className: 'full_screen_modal_left_image_box' }, { children: _jsx("div", Object.assign({ className: clsx('full_screen_modal_left_image', {
                                        is_active: id === imageIndex,
                                    }), "data-value": id, onClick: onClickImage, role: 'presentation' }, { children: _jsx(Image, { allowContextMenu: false, alt: '', isObjectFitContain: true, src: value, useImage: true }) })) }), id))) }))) })), _jsx("div", Object.assign({ className: `full_screen_modal_left_clickable ${isOpen ? 'is_open' : 'is_close'}`, onClick: toggleIsOpen, role: 'presentation' }, { children: _jsx("i", { className: 'arrow_icon' }) }))] })), isOpen && (_jsx("div", { className: 'full_screen_modal_left_bg', onClick: hideIsOpen, role: 'presentation' }))] }));
};
FullScreenModalLeft.propTypes = {
    changeActiveColumn: propFunc().isRequired,
    imageIndex: propNumber().isRequired,
    images: propArrayShape().isRequired,
    onClickImage: propFunc().isRequired,
};
export default FullScreenModalLeft;
